// src/store/slices/paymentSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as paymentApi from '../api/payment';

export const createPaymentOrder = createAsyncThunk(
  'payment/createPaymentOrder',
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await paymentApi.createPaymentOrder(paymentData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create payment order');
    }
  }
);

export const verifyPayment = createAsyncThunk(
  'payment/verifyPayment',
  async ({ orderId }, { rejectWithValue }) => {
    try {
      const response = await paymentApi.verifyPayment({ orderId });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to verify payment');
    }
  }
);

const initialState = {
  paymentDetails: null,   // { redirectUrl, orderId, amount, transactionId }
  verificationResult: null,
  loading: {
    createPayment: false,
    verifyPayment: false
  },
  error: {
    createPayment: null,
    verifyPayment: null
  }
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    resetPayment: (state) => {
      state.paymentDetails = null;
      state.verificationResult = null;
      state.error.createPayment = null;
      state.error.verifyPayment = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentOrder.pending, (state) => {
        state.loading.createPayment = true;
        state.error.createPayment = null;
      })
      .addCase(createPaymentOrder.fulfilled, (state, action) => {
        state.paymentDetails = action.payload.data;
        state.loading.createPayment = false;
      })
      .addCase(createPaymentOrder.rejected, (state, action) => {
        state.loading.createPayment = false;
        state.error.createPayment = action.payload?.message || 'Failed to create payment order';
      });

    builder
      .addCase(verifyPayment.pending, (state) => {
        state.loading.verifyPayment = true;
        state.error.verifyPayment = null;
      })
      .addCase(verifyPayment.fulfilled, (state, action) => {
        state.verificationResult = action.payload.data;
        state.loading.verifyPayment = false;
      })
      .addCase(verifyPayment.rejected, (state, action) => {
        state.loading.verifyPayment = false;
        state.error.verifyPayment = action.payload?.message || 'Failed to verify payment';
      });
  }
});

export const { resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;